"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.sort");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _utils = require("../utils");
var _basic = require("mockjs/src/mock/random/basic");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 计划、任务时间区间选择
 * 目前必填，非必填请自行改造
 */
/** mixins */

/** services */

/** utils */

/** statics */
var DEFAULT_START = '06:00';
var DEFAULT_END = '23:59';
var STEP = 30; // 单位 分钟
var STATUS_IDLE = 'idle'; // 空闲状态
var STATUS_USED = 'used'; // 已使用状态
var _default2 = exports.default = {
  mixins: [_dialog.default],
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    custom: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // planTaskInfoPk 针对任务场景，可以选择自己当前占用掉的时间
    ptpk: {
      type: String,
      default: ''
    },
    planTaskDate: {
      type: String,
      default: ''
    },
    actualPlanTaskFlag: {
      type: String,
      default: ''
    },
    // 挂载省市区字段的对象
    targetForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 开始、结束时间 字段的key
    keyList: {
      type: Array,
      default: function _default() {
        return ['starttime', 'endtime'];
      }
    },
    // 校验用的keykey（针对多级form表单使用）
    propKeyList: {
      type: [Array, undefined],
      default: function _default() {
        return undefined;
      }
    },
    // 是否需要中间的横杠 (仅在inline模式下生效)
    pickerLine: {
      type: Boolean,
      default: false
    },
    // 是否行内
    inline: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: [String],
      default: ''
    },
    startLabel: {
      type: String,
      default: ''
    },
    endLabel: {
      type: String,
      default: ''
    },
    startRules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    endRules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 排除的时间段
    getExcludeArray: {
      type: Function,
      default: function _default() {
        // demo [{start: 08:00, end: 09:30, key: xxx }] key 用于过滤 excludeActKey 字段
        return [];
      }
    }
  },
  data: function data() {
    return {
      step: STEP,
      // 时间块间隔分钟
      defaultTimeList: [],
      rules: {
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      },
      /** 已占用数据 */
      usedLoading: false,
      usedList: []
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    compStartLabel: function compStartLabel() {
      if (this.inline) {
        return this.startLabel || '';
      } else {
        return this.startLabel || this.$t('common.startDatetime');
      }
    },
    compEndLabel: function compEndLabel() {
      if (this.inline) {
        return this.endLabel || '';
      } else {
        return this.endLabel || this.$t('common.EndDatetime');
      }
    },
    startKey: function startKey() {
      var keys = this.keyList || [];
      return keys[0];
    },
    endKey: function endKey() {
      var keys = this.keyList || [];
      return keys[1];
    },
    /** props */propStartKey: function propStartKey() {
      var keys = this.propKeyList || this.keyList || [];
      return keys[0];
    },
    propEndKey: function propEndKey() {
      var keys = this.propKeyList || this.keyList || [];
      return keys[1];
    },
    //
    dialogTitle: function dialogTitle() {
      return this.$t('common.selectTimeRange');
    },
    // 依据数据格式化出来的列表，用于展示
    formatList: function formatList() {
      var sortArr = this.checkedSortList;
      var timeList = this.defaultTimeList;
      if (sortArr.length === 1) {
        // 已选中一个
        var targetArr = this.getInRange() || [];
        // console.log(9999, targetArr)
        return timeList.map(function (item) {
          var outClip = targetArr.indexOf(item.sortIndex) < 0;
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            disabled: item.status !== STATUS_IDLE || outClip
          });
        });
      } else if (sortArr.length === 2) {
        // 已选中两个
        var _targetArr = this.getInRange() || [];
        return timeList.map(function (item) {
          var sortIndex = item.sortIndex;
          var outClip = _targetArr.indexOf(sortIndex) < 0;
          var inRange = sortIndex >= sortArr[0] && sortIndex <= sortArr[1];
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            disabled: item.status !== STATUS_IDLE || outClip,
            inRange: inRange
          });
        });
      } else {
        // 其他情况简单处理
        return timeList.map(function (item) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            disabled: item.status !== STATUS_IDLE
          });
        });
      }
    },
    // 已选中的时间块的sortIndex 并排序
    checkedSortList: function checkedSortList() {
      return this.defaultTimeList.filter(function (i) {
        return i.checked;
      }).map(function (i) {
        return i.sortIndex;
      }).sort(function (a, b) {
        return a - b;
      });
    },
    // 选中的item数据 并排序
    checkedItemList: function checkedItemList() {
      return this.defaultTimeList.filter(function (i) {
        return i.checked;
      }).sort(function (a, b) {
        return a.sortIndex - b.sortIndex;
      });
    },
    // 用于watch
    checkedWatch: function checkedWatch() {
      return this.checkedItemList.map(function (item) {
        return "".concat(item.startTxt, "-").concat(item.endTxt);
      }).join(',');
    },
    // 是否选中至少一个
    canSubmit: function canSubmit() {
      return this.checkedSortList.length > 0;
    }
  },
  watch: {
    isShowModel: {
      deep: true,
      immediate: true,
      handler: function handler(val, oldVal) {
        if (val && val !== oldVal) {
          this.initTimeClip();
          this.initTimePicker();
          this.queryUsedList();
          this.initExcludeTime();
        }
      }
    }
  },
  methods: {
    // 加载已占用的时间数据
    queryUsedList: function queryUsedList() {
      var _this = this;
      // console.log('queryUsedList')
      if (this.planTaskDate) {
        var params = {
          planTaskDate: this.planTaskDate,
          actualPlanTaskFlag: this.actualPlanTaskFlag,
          timeList: [{
            startTime: DEFAULT_START,
            endTime: DEFAULT_END
          }]
        };
        this.usedLoading = true;
        (0, _doubleWeekPlan.getTimeList)(params).then(function (res) {
          var _ref = res || {},
            data = _ref.data;
          _this.initUsedTime(data || []);
        }).finally(function () {
          _this.usedLoading = false;
        });
      }
    },
    // 初始化占用掉的时间
    initUsedTime: function initUsedTime(usedArr) {
      var _this2 = this;
      var arr = usedArr.filter(function (i) {
        if (_this2.ptpk) {
          return i.planTaskInfoPk !== _this2.ptpk;
        } else {
          return true;
        }
      });
      // console.log(123, this.ptpk, arr)
      // api占用的
      arr.forEach(function (info) {
        var uStart = _this2.getTimenums(info.planTaskStartTime);
        var uEnd = _this2.getTimenums(info.planTaskEndTime);
        _this2.defaultTimeList.forEach(function (item) {
          if (item.start >= uStart && item.end <= uEnd) {
            item.status = STATUS_USED;
          }
        });
      });
    },
    // 外部传入占用时间初始化
    initExcludeTime: function initExcludeTime() {
      var _this3 = this;
      // console.log(initExcludeTime)
      // 外部传入占用的
      var arr = this.getExcludeArray() || [];
      arr.forEach(function (info) {
        if (!info.start || !info.end) {
          return false;
        }
        var uStart = _this3.getTimenums(info.start);
        var uEnd = _this3.getTimenums(info.end);
        _this3.defaultTimeList.forEach(function (item) {
          if (item.start >= uStart && item.end <= uEnd) {
            item.status = STATUS_USED;
          }
        });
      });
    },
    // 初始化选中的时间
    initTimePicker: function initTimePicker() {
      console.log('initTimePicker');
      var startTimeTxt = this.startKey ? this.targetForm[this.startKey] : '';
      var endTimeTxt = this.endKey ? this.targetForm[this.endKey] : '';
      console.log(this.startKey, this.endKey, startTimeTxt, endTimeTxt);
      this.defaultTimeList.forEach(function (item) {
        var isChecked = false;
        if (startTimeTxt && item.startTxt === startTimeTxt) {
          isChecked = true;
        } else if (endTimeTxt && item.endTxt === endTimeTxt) {
          // 截止的逻辑可能会调整。
          isChecked = true;
        }
        item.checked = isChecked;
      });
    },
    // 更新外部数据
    updateOutside: function updateOutside(val) {
      if (val && val.length && val.length === 2) {
        this.setVal(this.startKey, val[0]);
        this.setVal(this.endKey, val[1]);
      } else {
        this.setVal(this.startKey, '');
        this.setVal(this.endKey, '');
      }
      console.log('更新外部数据', this.startKey, val[0], this.endKey, val[1]);
    },
    // 外部数据赋值
    setVal: function setVal(key, val) {
      if (this.targetForm) {
        if (key) {
          // this.targetForm[key] = val
          this.$set(this.targetForm, key, val);
        }
      }
    },
    // 获取选中范围内的区间
    getInRange: function getInRange() {
      var sortArr = this.checkedSortList;
      // 需要判定比较多
      var totalArr = [];
      var arr = [];
      // 拆分区间
      this.defaultTimeList.forEach(function (item) {
        if (item.status === STATUS_IDLE) {
          arr.push(item.sortIndex);
        } else {
          // 赋值并清空
          if (arr.length !== 0) {
            totalArr.push(arr);
            arr = [];
          }
        }
      });
      // 最后一个区间需要push
      if (arr.length !== 0) {
        totalArr.push(arr);
        arr = [];
      }
      // console.log('targetarr', 1, totalArr, sortArr)
      var targetArr = [];
      var targetIndex = sortArr[0];
      totalArr.some(function (arr) {
        if (arr.indexOf(targetIndex) >= 0) {
          targetArr = [].concat(arr);
          return true;
        } else {
          return false;
        }
      });
      // console.log('targetarr', 2, targetArr, sortArr[0])

      return targetArr;
    },
    /**
     * 依据时间获取对应 时间戳
     * @param {string} timeStr // 时间str，格式为 xx:xx
     * @return {number} 如果没格式化成功则返还 0; 成功则返还具体分钟
     */
    getTimenums: _utils.getTimenums,
    /**
     * 依据时间戳获取对应time str
     */
    getTimeStr: _utils.getTimeStr,
    // 加0
    addZero: _utils.addZero,
    // 初始化时间块
    initTimeClip: function initTimeClip() {
      // console.log('initTimeClip')
      var start = this.getTimenums(DEFAULT_START);
      var end = this.getTimenums(DEFAULT_END);
      // console.log(999, start, end)
      var arr = [];
      var curStart = start;
      var sortIndex = 0;
      if (start !== undefined && end !== undefined) {
        if (end <= start) {
          // 开始结束时间设定有问题
          console.log('开始结束时间设定有问题，初始化失败');
        } else {
          while (end > curStart) {
            var curEnd = curStart + this.step > end ? end : curStart + this.step;
            arr.push({
              key: "".concat(curStart, "_").concat(curEnd),
              sortIndex: sortIndex,
              start: curStart,
              startTxt: this.getTimeStr(curStart),
              end: curEnd,
              endTxt: this.getTimeStr(curEnd),
              txt: "".concat(this.getTimeStr(curStart), " - ").concat(this.getTimeStr(curEnd)),
              // [used：已使用； idle：空闲；]
              status: STATUS_IDLE,
              // status: sortIndex % 9 === 3 ? STATUS_USED : STATUS_IDLE, // 测试逻辑，后续删除
              checked: false
            });
            // 后续处理
            curStart = curEnd;
            sortIndex++;
          }
          this.defaultTimeList = arr;
          // 排除传入的时间块
          this.initExcludeTime();
        }
      }
    },
    // 选择时间处理
    timeClickHandle: function timeClickHandle(item) {
      var sortIndex = item.sortIndex;
      var sortArr = this.checkedSortList;
      // 取消选中直接过（兼容，防止默认传入数据是不能选中的）
      if (sortArr.indexOf(sortIndex) >= 0) {
        // 取消
        this.defaultTimeList.some(function (info) {
          var status = info.sortIndex === sortIndex;
          if (status) {
            info.checked = !info.checked;
          }
          return status;
        });
      } else {
        // 选中状态下 检测 是否可选中
        if (item.disabled) {
          return false;
        }
        if (sortArr.length < 2) {
          // 2个以内选中
          this.defaultTimeList.some(function (info) {
            var status = info.sortIndex === sortIndex;
            if (status) {
              info.checked = !info.checked;
            }
            return status;
          });
        } else {
          // 选中超出2个，计算获取新的选中区间
          var startSort = sortArr[0];
          var endSort = sortArr[1];
          if (sortIndex > endSort) {
            endSort = sortIndex;
          } else if (sortIndex < startSort) {
            startSort = sortIndex;
          } else {
            // 在中间
            endSort = sortIndex;
          }
          // 变更选中
          var newSortArr = [startSort, endSort];
          this.updateTimeList(newSortArr);
        }
      }
    },
    // 更新timerange数据
    updateTimeList: function updateTimeList(arr) {
      this.defaultTimeList.forEach(function (item) {
        item.checked = arr.indexOf(item.sortIndex) >= 0;
      });
    },
    //
    openDialog: function openDialog() {
      if (!this.isDisabled) {
        this.isShowModel = true;
      }
    },
    // 确认修改时间
    saveItem: function saveItem() {
      var startTime = '';
      var endTime = '';
      var arr = this.checkedItemList || [];
      if (arr.length === 1) {
        startTime = arr[0].startTxt;
        endTime = arr[0].endTxt;
      } else if (arr.length >= 2) {
        startTime = arr[0].startTxt;
        endTime = arr[1].endTxt;
      }
      //
      // console.log('watch checkedItemList', [startTime, endTime])
      this.updateOutside([startTime, endTime]);
      this.$emit('change');
      this.isShowModel = false;
    }
  }
};